// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__AcdNN","img":"Icon_img__r8h0f"};